import clsx from "clsx";
import GradientWrapper from "../misc/Gradient"

type PillProps = {
    label: string
    tilt?: string;
}

export default function Pill({ label, tilt }: PillProps) {
    return (
        <div className={clsx(
            "relative flex justify-center items-center bg-white px-4 py-2 border-2 border-white rounded-full",
            tilt
        )}>
            <p className="z-50 font-20-bold text-green-800 leading-[135%]">
                {label}
            </p>
            <GradientWrapper gradient="bg-gradient-smooth-light" rounded="rounded-full" />
        </div>
    )
}